import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Home } from './pages/Home';
import { CaseStudy } from './pages/CaseStudy';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
const HOME_CANONICAL_URL = 'https://yetudesignlab.com/';
export function App() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    const existingCanonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (pathname !== '/') {
      existingCanonical?.remove();
      return;
    }
    const canonical = existingCanonical ?? document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', HOME_CANONICAL_URL);
    if (!existingCanonical) {
      document.head.appendChild(canonical);
    }
  }, [pathname]);
  return <Routes data-id="element-0" data-mp="28sbb5328r364">
      <Route path="/" element={<Home data-id="element-2" data-mp="23vuokdaowwv5" />} data-id="element-1" data-mp="28s2ynca15zvg" />
      <Route path="/work/:slug" element={<CaseStudy data-id="element-4" data-mp="23v2sl1d6kx4c" />} data-id="element-3" data-mp="23u9t8lgjx9w8" />
      <Route path="/blog" element={<Blog data-id="element-6" data-mp="3ikh5c1uvgeva" />} data-id="element-5" data-mp="23ti5fwt74ggi" />
      <Route path="/blog/:slug" element={<BlogPost data-id="element-8" data-mp="3ihv2gfixenje" />} data-id="element-7" data-mp="3iiwg8rrbto4t" />
    </Routes>;
}